import React, { useEffect, useState } from "react";
import Header from "../../components/navigation/Header";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Button,
  Grid,
  Paper,
  Typography,
  Chip,
  Stack,
  Card,
  Tabs,
  Tab,
  IconButton,
  CircularProgress,
  Skeleton,
} from "@mui/material";
import NoInvigilation from "../../assets/MyExams/NoInvigilation.png";
import NoData from "../../assets/MyExams/NoData.png";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import RoomIcon from "@mui/icons-material/Room";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { useNavigate } from "react-router-dom";
import { useMediaQuery, useTheme } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { evaluationData, invigilationData } from "../../utils/apiService";
import { useLoader } from "../../components/KenLoader";
import { formatDisplayDate, formatDisplayTime } from "../../utils/dateUtils";

interface Exam {
  subject: string;
  code: string;
  type: string;
  time: string;
  room: string;
  bgColor?: string;
  ongoing?: boolean;
}

interface Schedule {
  date: string;
  exams: Exam[];
}

const useStyles = makeStyles(() => ({
  header: {
    fontSize: "18px",
    fontWeight: "500",
  },
  container: {
    borderRadius: "8px",
    position: "relative",
    overflow: "auto",
  },
  EvaluationCard: {
    padding: "16px",
    backgroundColor: "#F6F8FB",
    borderRadius: "12px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  mobileCard: {
    padding: "16px",
    backgroundColor: "#F6F8FB",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  mobileCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
  },
  mobileCardTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#080018",
    lineHeight: 1.4,
  },
  mobileMeta: {
    fontSize: "14px",
    color: "#585A64",
  },
  dueChip: {
    padding: "6px 12px",
    borderRadius: "999px",
    border: "1px solid #373A45",
    fontSize: "12px",
    fontWeight: 500,
    color: "#373A45",
    backgroundColor: "#F6F8FB",
    width: "fit-content",
  },
  semesterHeading: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#373A45",
    marginBottom: "12px",
  },
  cardHeading: {
    fontSize: "16px",
    fontWeight: 600,
  },
  bundleText: {
    fontSize: "14px",
  },
  paperText: {
    fontSize: "16px",
    color: "#585A64",
    fontWeight: 600,
    marginTop: 32,
  },
  invigilationDate: {
    marginBottom: "8px !important",
    fontWeight: 500,
    color: "#6b7280", // text.secondary
  },
  invigilationCard: {
    padding: "16px",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginBottom: "16px",
  },
  ongoingChip: {
    backgroundColor: "#d9c2f1 !important",
    color: "black !important",
    fontWeight: 500,
  },
  timeRoom: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  tabRoot: {
    textTransform: "capitalize", // keep tab labels capitalized
    fontSize: "16px",
    fontWeight: 500,
  },
}));

const FacultyExams = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [cardData, setCardData] = useState<any[]>([]);
  const [invigilationSchedule, setInvigilationSchedule] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const { showLoader, hideLoader } = useLoader();
  const classes = useStyles();
  const navigate = useNavigate();

  const userName = localStorage.getItem("contact_name");

  useEffect(() => {
    showLoader();
    Promise.all([evaluationData(), invigilationData()])
      .then(([evalRes, invigRes]) => {
        console.log(evalRes, "evaluation data response");
        const response = evalRes?.data;
        console.log(response, "dsfbdb");
        const tempArray =
          response
            ?.map((item: any) => ({
              id: item?.UniqueBundleNumber,
              title: item?.CourseName,
              courseCode: item.CourseCode,
              bundleCode: item.UniqueBundleNumber,
              papers: item.examConnectionCount,
              format: item.ExamFormat,
              status: item.status,
              dueDate: formatDisplayDate(item?.EvaluationDueDate),
              semester: item?.Semester,
              submittedOn: "13-08-2025",
              ExamType: item?.ExamType,
              ExamFormat: item?.ExamFormat,
              evaluationType: item?.evaluationType,
              AssignedBundleID: item?.AssignedBundleID,
            }))
            .filter((item: any) => item.status === "Pending" || item.status === "Partially Evaluated") || [];
        setCardData(tempArray);

        console.log(invigRes, "Invigilation data response");
        const invigResponse = invigRes?.data;
        if (invigResponse && Array.isArray(invigResponse)) {
          const tempArray: Schedule[] = invigResponse.map((item: any) => {
            const startDateTime =
              item?.StartDateandTime ||
              item?.startDateandTime ||
              item?.startDateendTime ||
              item?.StartDateEndTime;
            return {
              date: formatDisplayDate(
                startDateTime || item?.DueDate || item?.date
              ),
              exams: [
                {
                  subject: item?.CourseName || "Unknown Subject",
                  code: item?.CourseCode || "N/A",
                  type: item?.ExamFormat || item?.ExamType || "N/A",
                  time: formatDisplayTime(startDateTime) || "TBD",
                  room: item?.Hall || "TBD",
                  bgColor: "#F9F9FB",
                  ongoing: item?.status === "Ongoing",
                  Semester: item?.Semester,
                  ExamType: item?.ExamType,
                },
              ],
            };
          });
          setInvigilationSchedule(tempArray);
        } else {
          console.warn("No valid data found, using fallback data.");
          setInvigilationSchedule([]);
        }
      })
      .catch((err: any) => {
        console.error("Error in fetching data:", err);
        setInvigilationSchedule([]);
      })
      .finally(() => {
        hideLoader();
        setLoading(false);
      });
  }, []);
  interface CardData {
    title: string;
    courseCode: string;
    bundleCode: string;
    papers: string;
    buttonText: string;
    dueDate: string;
    semester: string;
    status: string;
  }

  interface InvigilationData {
    date: string;
    exams: {
      subject: string;
      code: string;
      type: string;
      time: string;
      room: string;
      AssignedBundleID: string;
      ongoing?: boolean;
      bgColor: string;
    }[];
  }

  const groupedCardData = cardData.reduce<Record<string, CardData[]>>(
    (acc, item) => {
      if (!acc[item.semester]) {
        acc[item.semester] = [];
      }
      acc[item.semester].push(item);
      return acc;
    },
    {}
  );

  const [value, setValue] = useState("one");
  const [activeTab, setActiveTab] = useState<"Assigned" | "Completed">(
    "Assigned"
  );

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const goToEvaluation = (card: any) => {
    navigate("/faculty/evaluationRequests", {
      state: {
        data: card,
      },
    });
  };

  const renderDesktopSkeleton = () => (
    <div>
      <Header title={`Hi ${userName || "..."}, have a great day!`} />
      <Grid
        container
        spacing={4}
        mt={"32px"}
        height={"calc(100vh - 165px)"}
        className={classes.container}
      >
        <Grid size={{ md: 8 }} component={Paper} className="p-4">
          <Box className="d-flex justify-content-between align-items-center">
            <Skeleton variant="text" width={220} height={28} />
            <Skeleton
              variant="rectangular"
              width={96}
              height={36}
              sx={{ borderRadius: 1 }}
            />
          </Box>
          <Box className="mt-4">
            <Grid container spacing={4}>
              {Array.from({ length: 6 }).map((_, idx) => (
                <Grid key={idx} size={{ md: 4 }}>
                  <Box className={classes.EvaluationCard}>
                    <Skeleton variant="text" height={24} width="80%" />
                    <Skeleton variant="text" height={18} width="70%" />
                    <Skeleton variant="text" height={18} width="40%" />
                    <Skeleton
                      variant="rectangular"
                      height={36}
                      sx={{ borderRadius: 1, mt: 2 }}
                    />
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>
        <Grid size={{ md: 4 }} component={Paper} className="p-4">
          <Skeleton variant="text" width={180} height={28} />
          <Stack spacing={2} mt={2}>
            {Array.from({ length: 3 }).map((_, idx) => (
              <Card key={idx} className={classes.invigilationCard}>
                <Skeleton variant="text" width="70%" />
                <Skeleton variant="text" width="60%" />
                <Skeleton variant="text" width="50%" />
              </Card>
            ))}
          </Stack>
        </Grid>
      </Grid>
    </div>
  );

  const renderMobileSkeleton = () => (
    <div>
      <Header title={`Hi ${userName || "..."}`} />
      <Box p={2}>
        <Skeleton variant="text" width={180} height={28} />
        <Stack spacing={2} mt={2}>
          {Array.from({ length: 4 }).map((_, idx) => (
            <Card key={idx} className={classes.mobileCard}>
              <Skeleton variant="text" width="70%" />
              <Skeleton variant="text" width="50%" />
              <Skeleton variant="text" width="60%" />
            </Card>
          ))}
        </Stack>
      </Box>
    </div>
  );

  if (loading) {
    return isMobile ? renderMobileSkeleton() : renderDesktopSkeleton();
  }

  return (
    <div>
      <Header title={`Hi ${userName}, have a great day!`} />

      {isMobile ? (
        <>
          <Box
            display={"flex"}
            justifyContent={"center"}
            height={isMobile ? "100%" : "calc(100vh - 165px)"}
          >
            <Box>
              <Tabs
                value={value}
                onChange={handleChange}
                textColor="secondary"
                aria-label="exam tabs"
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "#FFC923",
                    height: 3,
                    borderRadius: 3,
                  },
                }}
                sx={{ "& .MuiTab-root": { minHeight: 48 } }}
              >
                <Tab
                  sx={{ textTransform: "capitalize" }}
                  classes={{ root: classes.tabRoot }}
                  value="one"
                  label="Evaluation requests"
                />
                <Tab
                  sx={{ textTransform: "capitalize" }}
                  classes={{ root: classes.tabRoot }}
                  value="two"
                  label="Invigilation schedule"
                />
              </Tabs>
            </Box>
          </Box>
          {value === "one" && (
            <Box className="w-100 mt-4 d-flex justify-content-center">
              <Box
                sx={{
                  display: "inline-flex",
                  padding: "4px",
                  borderRadius: "12px",
                  backgroundColor: "#F6F8FB",
                }}
              >
                {["Assigned", "Completed"].map((tab) => {
                  const isActive = activeTab === tab;
                  return (
                    <Button
                      key={tab}
                      disableElevation
                      onClick={() =>
                        setActiveTab(tab as "Assigned" | "Completed")
                      }
                      sx={{
                        minWidth: "120px",
                        px: 2.5,
                        height: "40px",
                        borderRadius: "8px",
                        textTransform: "none",
                        fontSize: "14px",
                        fontWeight: 600,
                        backgroundColor: isActive ? "#080018" : "transparent",
                        color: isActive ? "#ffffff" : "#585A64",
                        "&:hover": {
                          backgroundColor: isActive ? "#080018" : "#E4E6EB",
                        },
                      }}
                    >
                      {tab}
                    </Button>
                  );
                })}
              </Box>
            </Box>
          )}
          <Box className="m-4">
            {value === "one" ? (
              activeTab === "Assigned" ? (
                Object.entries(groupedCardData).map(([semester, cards]) => (
                  <>
                    {cards.length > 0 ? (
                      <Box key={semester} sx={{ mb: 4 }}>
                        <Typography className={classes.semesterHeading}>
                          {semester}
                        </Typography>
                        <Stack spacing={2}>
                          {cards
                            .filter((card) => card.status !== "Submitted")
                            .map((card) => (
                              <Box
                                key={card.courseCode}
                                className={classes.mobileCard}
                                sx={{ cursor: "pointer" }}
                                onClick={() => goToEvaluation(card)}
                              >
                                <Box className={classes.mobileCardHeader}>
                                  <Typography
                                    className={classes.mobileCardTitle}
                                  >
                                    {card.title} - {card.courseCode}
                                  </Typography>
                                  <IconButton
                                    size="small"
                                    disableRipple
                                    disableFocusRipple
                                    aria-label="View details"
                                    sx={{ color: "#080018" }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      goToEvaluation(card);
                                    }}
                                  >
                                    <ArrowForwardIcon sx={{ fontSize: 20 }} />
                                  </IconButton>
                                </Box>
                                <Typography className={classes.mobileMeta}>
                                  Bundle code: {card.bundleCode}
                                </Typography>
                                <Typography className={classes.mobileMeta}>
                                  {card.papers}
                                </Typography>
                                <Box className={classes.dueChip}>
                                  Due date: {card.dueDate}
                                </Box>
                              </Box>
                            ))}
                        </Stack>
                      </Box>
                    ) : (
                      <Box
                        className="d-flex flex-column justify-content-center align-items-center mt-4"
                        sx={{ height: "320px" }}
                      >
                        <img src={NoData} alt="No Data" />
                        <Typography className="w-75 text-center mt-2">
                          You have no completed evaluation requests yet
                        </Typography>
                      </Box>
                    )}
                  </>
                ))
              ) : (
                Object.entries(groupedCardData).map(([semester, cards]) => (
                  <>
                    {cards.length > 0 ? (
                      <Box key={semester} sx={{ mb: 4 }}>
                        <Typography className={classes.semesterHeading}>
                          {semester}
                        </Typography>
                        <Stack spacing={2}>
                          {cards
                            .filter((card) => card.status === "Submitted")
                            .map((card) => (
                              <Box
                                key={card.courseCode}
                                className={classes.mobileCard}
                              >
                                <Box className={classes.mobileCardHeader}>
                                  <Typography
                                    className={classes.mobileCardTitle}
                                  >
                                    {card.title} - {card.courseCode}
                                  </Typography>
                                  <IconButton
                                    size="small"
                                    disableRipple
                                    disableFocusRipple
                                    aria-label="View details"
                                    sx={{ color: "#080018" }}
                                  >
                                    <ArrowForwardIcon sx={{ fontSize: 20 }} />
                                  </IconButton>
                                </Box>
                                <Typography className={classes.mobileMeta}>
                                  Bundle code: {card.bundleCode}
                                </Typography>
                                <Typography className={classes.mobileMeta}>
                                  {card.papers}
                                </Typography>
                                <Box className={classes.dueChip}>
                                  Due date: {card.dueDate}
                                </Box>
                              </Box>
                            ))}
                        </Stack>
                      </Box>
                    ) : (
                      <Box
                        className="d-flex flex-column justify-content-center align-items-center mt-4"
                        sx={{ height: "320px" }}
                      >
                        <img src={NoData} alt="No Data" />
                        <Typography className="w-75 text-center mt-2">
                          You have no completed evaluation requests yet
                        </Typography>
                      </Box>
                    )}
                  </>
                ))
              )
            ) : (
              <Stack spacing={3}>
                {invigilationSchedule.length > 0 ? (
                  invigilationSchedule.map((schedule, idx) => (
                    <Stack spacing={2} key={idx}>
                      {schedule.exams.map((exam: any, i: number) => (
                        <Card
                          key={i}
                          className={classes.invigilationCard}
                          sx={{
                            backgroundColor: exam.bgColor,
                            borderLeft: "2px solid #080018",
                          }}
                        >
                          <Stack direction="row" alignItems="center" gap={1}>
                            <CalendarTodayIcon
                              sx={{ fontSize: 16, color: "#6b7280" }}
                            />
                            <Typography className={classes.invigilationDate}>
                              {schedule.date}
                            </Typography>
                          </Stack>
                          <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Typography className={classes.mobileCardTitle}>
                              {exam.subject} - {exam.code}
                            </Typography>
                            {exam.ongoing && (
                              <Chip
                                label="Ongoing"
                                size="small"
                                className={classes.ongoingChip}
                              />
                            )}
                          </Stack>
                          <Typography className={classes.mobileMeta}>
                            {exam.type}
                          </Typography>
                          <Stack
                            direction="row"
                            spacing={2}
                            alignItems="center"
                          >
                            <Box className={classes.timeRoom}>
                              <AccessTimeIcon fontSize="small" />
                              <Typography className={classes.mobileMeta}>
                                {exam.time}
                              </Typography>
                            </Box>
                            <Box className={classes.timeRoom}>
                              <RoomIcon
                                fontSize="small"
                                sx={{ color: "#373A45" }}
                              />
                              <Typography className={classes.mobileMeta}>
                                {exam.room}
                              </Typography>
                            </Box>
                          </Stack>
                        </Card>
                      ))}
                    </Stack>
                  ))
                ) : (
                  <Box
                    className="d-flex flex-column justify-content-center align-items-center mt-4"
                    sx={{ height: "320px" }}
                  >
                    <img src={NoInvigilation} alt="No Invigilation" />
                    <Typography className="w-75 text-center mt-2">
                      Data will be available once the schedule is ready
                    </Typography>
                  </Box>
                )}
              </Stack>
            )}
          </Box>
        </>
      ) : (
        <Grid
          container
          spacing={4}
          mt={isMobile ? "16px" : "32px"}
          height={isMobile ? "100%" : "calc(100vh - 165px)"}
          padding={isMobile ? "12px" : "0px"}
          className={classes.container}
        >
          <Grid size={{ md: 8 }} component={Paper} className="p-4">
            <Box className="d-flex justify-content-between align-items-center">
              <Typography className={classes.header}>
                Evaluation requests ({cardData.length})
              </Typography>
              <Button
                variant="primary"
                onClick={() => navigate("/faculty/evaluation")}
              >
                View all
              </Button>
            </Box>
            <Box className="mt-4">
              {cardData.length > 0 ? (
                <Grid container spacing={4}>
                  {cardData.map((card, index) => (
                    <Grid key={card.courseCode} size={{ md: 4 }}>
                      <Box className={classes.EvaluationCard}>
                        <Box className="d-flex flex-column justify-content-between">
                          <Typography className={classes.cardHeading}>
                            {card.title}
                          </Typography>
                          <Typography className={classes.bundleText}>
                            Bundle code: {card.bundleCode}
                          </Typography>
                          <Typography className={classes.paperText}>
                            {card.papers} Papers
                          </Typography>
                        </Box>
                        <Box>
                          {card.status !== "Submitted" ? (
                            <Button
                              variant="secondary"
                              className="w-100 mt-4"
                              onClick={() => {
                                localStorage.setItem(
                                  "evaluationType",
                                  card?.evaluationType
                                );

                                navigate("/faculty/evaluationRequests", {
                                  state: {
                                    data: card,
                                  },
                                });
                              }}
                            >
                              Evaluate
                            </Button>
                          ) : null}
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Box
                  className="d-flex flex-column justify-content-center align-items-center mt-4"
                  sx={{ height: "400px" }}
                >
                  <img src={NoData} alt="No Data" />
                  <Typography className="w-50 text-center mt-2">
                    You have no evaluation requests
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid>

          {/* Right Side - Invigilation */}
          <Grid size={{ md: 4 }} component={Paper} className="p-4">
            <Typography className={classes.header}>
              Invigilation Schedule
            </Typography>
            <Box sx={{ p: 2 }}>
              {invigilationSchedule.length > 0 ? (
                invigilationSchedule.map((schedule, idx) => (
                  <Box key={idx}>
                    {schedule.exams.map((exam: any, i: number) => (
                      <Card
                        key={i}
                        className={classes.invigilationCard}
                        style={{
                          backgroundColor: exam.bgColor,
                          borderLeft: "2px solid #080018",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Typography variant="subtitle1" fontWeight={600}>
                            {exam.subject} - {exam.code}
                          </Typography>
                          {exam.ongoing && (
                            <Chip
                              label="Ongoing"
                              size="small"
                              className={classes.ongoingChip}
                              icon={
                                <Box
                                  sx={{
                                    bgcolor: "red",
                                    width: 8,
                                    height: 8,
                                    borderRadius: "50%",
                                  }}
                                />
                              }
                            />
                          )}
                        </Stack>
                        <Box className="d-flex flex-wrap justify-content-between align-items-center mb-2">

                        <Typography variant="body2" color="text.secondary">
                          Semester {exam.Semester} | {exam?.ExamType}
                        </Typography>
                         <Box className={classes.timeRoom}>
                            <CalendarTodayIcon
                              sx={{ fontSize: 16, color: "#373A45" }}
                            />
                            <Typography
                              variant="body2"
                            //   className={classes.invigilationDate}
                            >
                              {schedule.date}
                            </Typography>
                          </Box>
                          </Box>

                        <Stack direction="row" flexWrap={"wrap"} spacing={4} alignItems="center">
                          <Box className={classes.timeRoom}>
                            <AccessTimeIcon fontSize="small" />
                            <Typography variant="body2">{exam.time}</Typography>
                          </Box>
                          <Box className={classes.timeRoom}>
                            <RoomIcon
                              fontSize="small"
                              style={{ color: "#373A45" }}
                            />
                            <Typography variant="body2">{exam.room}</Typography>
                          </Box>

                         
                        </Stack>
                        
                      </Card>
                    ))}
                  </Box>
                ))
              ) : (
                <Box
                  sx={{ height: "60vh" }}
                  className="d-flex flex-column  justify-content-center align-items-center"
                >
                  <img src={NoInvigilation} alt={"No Invigilation"} />
                  <Typography className="w-50 text-center mt-4">
                    Data will be available once the schedule is ready
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default FacultyExams;
